




export default {
  props: {
    vitalSign: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      unitsWithSpaces: ['bpm', 'mg/dL', 'mmHg', 'lbs', 'hrs', 'hr', 'hours', 'hour', 'times', 'time', 'mins', 'min'],
    }
  },
  computed: {
    unitAndValue() {
      return `${this.vitalSign.value}${this.unitsWithSpaces.includes(this.vitalSign.unit) ? '&nbsp;' : ''}${this
        .vitalSign.unit || ''}`
    },
  },
}
